import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
	mainContainer: {
		flex: 1,
		padding: 0,
		height: "100%",
		width: "100%",
		maxWidth: "100%",
		minWidth: 0,
		minHeight: 0,
		display: "flex",
		flexDirection: "column",
	},

	contentWrapper: {
		height: "100%",
		minHeight: 0,
		minWidth: 0,
		overflow: "hidden",
		display: "flex",
		flexDirection: "column",
		flex: 1,
	},
}));

function MainContainer({ children }) {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer} maxWidth={false}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
}

export default MainContainer;
